import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../router';
import type { HeaderMenuItem } from '../components/BCPPageHeader';
import { getLogoutRedirectUrl } from '../utils/auth';

export const useHeaderMenuItems = (): HeaderMenuItem[] => {
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await fetch('/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('ログアウト処理に失敗しました', error);
    } finally {
      // 東商マイページトップにリダイレクト
      window.location.href = getLogoutRedirectUrl();
    }
  }, []);

  return useMemo(
    () => [
      {
        id: 'menu-settings',
        label: '設定',
        onSelect: () => navigate(ROUTES.SETTINGS),
      },
      {
        id: 'menu-inquiry',
        label: '問い合わせ',
        onSelect: () => navigate(ROUTES.INQUIRY),
      },
      {
        id: 'menu-inquiry',
        label: 'FAQ（よくあるご質問）',
        onSelect: () => navigate(ROUTES.INQUIRY),
      },
      {
        id: 'menu-terms',
        label: '利用規約',
        onSelect: () => navigate(ROUTES.TERMS),
      },
      {
        id: 'menu-logout',
        label: 'ログアウト',
        onSelect: handleLogout,
      },
    ],
    [navigate, handleLogout],
  );
};

export default useHeaderMenuItems;
